import { Toaster } from 'sonner'

export function SonnerToaster() {
  return <Toaster position="top-right" richColors closeButton expand={true} duration={5000} />
}
